@if (!showMore && content.length > length) {
  {{ content | slice: 0 : length | rtrim }}...
} @else {
  {{ content }}
}
@if (content.length > length) {
  <button
    type="button"
    class="btn btn-link p-0 text-decoration-none"
    (click)="showMore = !showMore">
    show {{ showMore ? 'less' : 'more' }}
  </button>
}
